import React from "react";
import { motion } from "framer-motion";

const MisionVision = () => {
    return (
    <motion.div
        className="max-w-screen-lg mx-auto px-4 py-16 mt-16"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
    >
    <h2 className="text-3xl font-bold text-blue-700 mb-10 text-center">
        Misión y Visión
    </h2>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <motion.div
            className="bg-white shadow-md rounded-xl p-6 border border-blue-200"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
        >
        <h3 className="text-xl font-semibold text-blue-600 mb-3">¿Cual es nuestra misión?</h3>
        <p className="text-gray-700 leading-relaxed text-justify">
        Somos una Institución de Educación Secundaria, 
        orientada a la formación integral de los estudiantes que ofrece una educación de calidad, 
        promoviendo el desarrollo de competencias, la participación adolescente, creatividad, 
        inclusión, estilos de vida saludable e interculturalidad con un clima institucional favorable, 
        soporte socioemocional, práctica de valores y compromiso ambientalista.
        </p>
        </motion.div>

        <motion.div
            className="bg-white shadow-md rounded-xl p-6 border border-blue-200"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
        >
        <h3 className="text-xl font-semibold text-blue-600 mb-3">¿Cual es nuestra visión</h3>
        <p className="text-gray-700 leading-relaxed text-justify">
        Al 2025, La Institución Educativa “La Inmaculada” aspira ser líder en educación de calidad y eficiencia, 
        competitiva a nivel local, regional, nacional e internacional, creativa e innovadora con estudiantes 
        comprometidos en la transformación de nuestra sociedad, exitosos para afrontar retos en la resolución 
        de problemas globales, asumiendo sus derechos y responsabilidades, con práctica de valores, 
        conciencia ambiental y proyecto de vida.
        </p>
        </motion.div>
    </div>
    </motion.div>
    );
};

export default MisionVision;
